import React from 'react'
import Slider from 'react-slick'

const About = () => {

    const testiSlider = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 600,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false
                },
            },
        ],
    }

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>About Us</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about all-section">
                <div className="container">
                    <div className="row justify-content-end">
                        <div className="col-lg-10">
                            <div className="about_left">
                                <img src="images/abt-2.jpg" alt />
                            </div>
                            <div className="about_right">
                                <h2 className="wow animate__animated animate__slideInRight" data-wow-delay="0.2s" data-wow-duration="1s">
                                    About
                                    <span>
                                        Spareland
                                    </span>
                                </h2>
                                <div className="abt_right_img">
                                    <img src="images/abt-1.jpg" alt />
                                    <div className="abt_txt wow animate__animated animate__slideInRight" data-wow-delay="0.3s" data-wow-duration="1s">
                                        <p>Lorem ipsum dolor sit amet, elit, sed do eiusmod tempor incididunt ut labore et
                                            dolore magna aliqua. </p>
                                        <p>
                                            Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut
                                            enim ad minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
                                            duis aute irure dolor in reprehenderit in voluptat dolore magna aliquat enim ad
                                            minim ve lorempsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut labore et dolore magna aliquanim ad minim veniam.
                                            ipsum dolor sit amet, consectetur adipisicing
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="abt_pg">
                            <h2>
                                Consectetur adipisicing elit Adipisicing elit
                            </h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p>
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                                mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                                voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
                                voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
                                consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore
                                magnam aliquam quaerat voluptatem Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                                do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="testimonial">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>
                                    happy clients
                                </h2>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Quis ipsum suspeno eiusmod tempor incididunt ut lab
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="testi_slider">
                        <Slider {...testiSlider}>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
            <section className="wcu all-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="wcu_left wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div className="wcu_left_img">
                                    <img src="images/wcu-1.jpg" alt />
                                </div>
                                <div className="wcu_left_txt">
                                    <h2>
                                        Unlock the<span className="d_block" />
                                        Potential of Your Land
                                    </h2>
                                    <div className="wcu_padding">
                                        <p>Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut
                                            enim ad
                                            minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                            tempor
                                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                            exercitation ullamco laboristempor incididunt ut labore et dolore magna aliqua. Ut
                                            enim
                                            ad minim veniam, quis </p>
                                        <ul>
                                            <li>
                                                Spare Land connects unused land with people who want to grow.
                                            </li>
                                            <li>
                                                We help solve the UK allotment shortage.
                                            </li>
                                            <li>
                                                Landowners can list plots easily and securely.
                                            </li>
                                            <li>
                                                Growers can find and rent space near them quickly.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="wcu_right wow animate__animated animate__slideInRight" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div className="wcu_right_txt">
                                    <h2>
                                        Why Choose <span className="d_block" />
                                        spareland
                                    </h2>
                                    <p>
                                        Lorem ipsum dolor sit amet, elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua dummy here lorem.
                                    </p>
                                    <p>
                                        Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim
                                        ad minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                        nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat duis aute
                                        irure dolor in reprehenderit in voluptat
                                    </p>
                                </div>
                                <div className="wcu_right_img">
                                    <img src="images/wcu-1.jpg" alt />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About